import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { completeUpdate, initializeList, updateFilter } from '../search-slice';
import { getSearchStore } from './store-manager';
import { Filter } from '../search-model';

interface SearchAppProps {
	initialList: any[],
	appName: string,
	initialFilters?: Filter[],
}


export const SearchApp = (props: React.PropsWithChildren<SearchAppProps>) => {

	const store = getSearchStore(props.appName);
	useEffect(() => {
		store.dispatch(initializeList(props.initialList, props.appName));
	
		props.initialFilters?.forEach(item => {
			const normalizedOptions = item.filterOptions.map(opt => ({
				...opt,
				filterValue: opt.filterValue.toLowerCase(),
			}));
	
			const normalizedFilter: Filter = {
				...item,
				filterOptions: normalizedOptions,
			};
	
			store.dispatch(updateFilter(normalizedFilter));
			store.dispatch(completeUpdate());
		});
	}, []);
	
	return (
		<Provider store={store}>
			{
				props.children
			}
		</Provider>
	);

};

SearchApp.defaultProps = {
	initialFilters: [],
};